import styled, { css } from 'styled-components';
import { Div } from '../common/helpers/StyledUtils';

type Props = {
  center?: boolean;
  light?: boolean;
  no_decorations?: boolean;
};

const FullscreenLayout = styled(Div)<Props>(({ theme, no_decorations, center, light }) => {
  const background_color = light
    ? theme.colors.surface.base.surface
    : theme.colors.surface.base.background;

  return css`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    padding-top: 124px;
    padding-bottom: 124px;
    box-sizing: border-box;
    background: ${no_decorations
      ? background_color
      : `${background_color} url('/images/${theme.mode === 'light' ? 'wave-light' : 'wave-dark'}.svg') no-repeat center center fixed`};
    ${center &&
    css`
      align-items: center;
      justify-content: center;
      text-align: center;
    `};
  `;
});

export default FullscreenLayout;
